export const staffManagementGettingStartedArticle = {
  title: 'Staff Management Hub: Getting Started',
  slug: 'staff-management-getting-started',
  content: `Staff Management Hub: Getting Started

Manage staff records, scheduling, and HR workflows.

1) Open Staff Management
- Go to /legal-hr/staff-management.

2) Core tabs
- Staff Directory, Org Chart, Time Clock, Work Rota, Holidays.
- Documents, Reviews, Analytics, and Payroll Prep are also available.

3) Add staff and leave
- Use the Add Staff flow to create new team members.
- Use Holidays to submit and approve leave.
`,
};
